// Copyright (c) 2023 Deere & Company

import DuplicatePinPlateAccordion from './duplicate-pin-plate-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.duplicatePinPlateRequest,
    duplicatePinPlateChanges: state.tcsm.wip.duplicatePinPlateView,
    duplicatePinPlateSearchFilters: state.tcsm.wip.duplicatePinPlateSearchFilters,
    length: state.tcsm.wip.duplicatePinPlateLength,
    selectedDealers: state.tcsm.wip.wipFacets.dealers

});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DuplicatePinPlateAccordion);



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/duplicate-pin-plate/index.js